import { useContext } from 'react';
import NavContext from '../context/navContext';

/**
 * useAuthContext is a convenience hook to access the auth context
 */
export default function useNavContext() {
  return useContext(NavContext);
}
